export const GET_STARTED_STEP_ID = 'new';
export const BUSINESS_STEP_ID = 'business';
export const APPLICANT_STEP_ID = 'applicant';
